import React from 'react';

import { CONTAINER_ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { LoadablePaint } from '@confluence/loadable';

const SpaceSettingsRelatedPagesRouteComponent = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SpaceSettingsRelatedPagesRouteComponent" */ './SpaceSettingsRelatedPagesRouteComponent.tsx'
			)
		).SpaceSettingsRelatedPagesRouteComponent,
});

export const SpaceSettingsRelatedPagesRoute: {
	({
		params: { spaceKey },
	}: {
		params: {
			spaceKey: any;
		};
	}): React.JSX.Element;
	NAVIGATION_PARAMS({
		name,
		params: { spaceKey },
	}: {
		name: any;
		params: {
			spaceKey: any;
		};
	}): {
		Screen: {
			screenEvent: {
				name: string;
				id: any;
			};
			pageState: {
				spaceKey: any;
				routeName: any;
			};
		};
		MainLayout: {
			navView: string;
			spaceKey: any;
			disableMinWidth: boolean;
		};
	};
} = ({
	params: { spaceKey },
}: {
	params: {
		spaceKey: any;
	};
}): React.JSX.Element => <SpaceSettingsRelatedPagesRouteComponent spaceKey={spaceKey} />;

SpaceSettingsRelatedPagesRoute.NAVIGATION_PARAMS = ({
	name,
	params: { spaceKey },
}: {
	name: any;
	params: {
		spaceKey: any;
	};
}): {
	Screen: {
		screenEvent: {
			name: string;
			id: any;
		};
		pageState: {
			spaceKey: any;
			routeName: any;
		};
	};
	MainLayout: {
		navView: string;
		spaceKey: any;
		disableMinWidth: boolean;
	};
} => ({
	Screen: {
		screenEvent: { name: 'spaceSettingsRelatedPages', id: spaceKey },
		pageState: { spaceKey, routeName: name },
	},
	MainLayout: {
		navView: CONTAINER_ADMIN_HOME_ID,
		spaceKey,
		disableMinWidth: true,
	},
});
